// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-container > .react-bootstrap-table {
  padding-top: 2rem;
}

.custom-table {
  width: 100%;
}

.custom-table > thead > tr > .selection-cell-header {
  text-align: left;
}

.custom-table > thead > tr {

  border-bottom: 2px solid rgba(138, 138, 138, 0.15);
}

.custom-table > tbody > tr {
  border-bottom: 2px solid rgba(138, 138, 138, 0.15);
}

.custom-table > tbody > tr:hover{
  background-color: #f0f0f0;
}
.custom-table.dark > tbody > tr:hover{
  background-color: #66A2FF26;
}

.custom-table > thead > tr > th {
  padding-top: 0.30rem;
  padding-bottom: 0.60rem;;
}

.custom-table > tbody > tr > td{
  padding-top: 0.30rem;
  padding-bottom: 0.30rem;
}

.react-bootstrap-table-pagination {
  display: flex;
  justify-content: flex-end;
  padding-top: 1em;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/DataTable/DataTable.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".custom-container > .react-bootstrap-table {\n  padding-top: 2rem;\n}\n\n.custom-table {\n  width: 100%;\n}\n\n.custom-table > thead > tr > .selection-cell-header {\n  text-align: left;\n}\n\n.custom-table > thead > tr {\n\n  border-bottom: 2px solid rgba(138, 138, 138, 0.15);\n}\n\n.custom-table > tbody > tr {\n  border-bottom: 2px solid rgba(138, 138, 138, 0.15);\n}\n\n.custom-table > tbody > tr:hover{\n  background-color: #f0f0f0;\n}\n.custom-table.dark > tbody > tr:hover{\n  background-color: #66A2FF26;\n}\n\n.custom-table > thead > tr > th {\n  padding-top: 0.30rem;\n  padding-bottom: 0.60rem;;\n}\n\n.custom-table > tbody > tr > td{\n  padding-top: 0.30rem;\n  padding-bottom: 0.30rem;\n}\n\n.react-bootstrap-table-pagination {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 1em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
